import { Space, Typography, message } from 'antd';
import { useEffect, useState } from 'react';

import DraggerSortableContainer from './dragger-sortable-container';
import DraggerZone from './dragger-zone';
import { useS3Upload } from 'lib/s3';

export function SpImgUploadList({
  required = false,
  defaults = [],
  onChange,
  title = '',
  description = '',
  maxLength = 5,
}) {
  const [fileList, setFileList] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const onPresentFiles = (files) => {
    setFileList(files);
    onChange?.(files);
  };

  const { mutate: mutateUpload, isPending: isPendingUpload } = useS3Upload({
    onSuccess: (res) => {
      const newFileList = fileList.map((ss) => {
        if (ss.uid === res?.uid) {
          const newSets = {
            ...ss,
            status: 'done',
            url: res?.url,
            name: res?.file_name,
            response: res,
          };

          return newSets;
        }

        return ss;
      });

      onPresentFiles(newFileList);
      messageApi.success(`อัปโหลดไฟล์ (${res?.file_name}) สำเร็จ`);
    },
    onError: () => {
      const newFileList = fileList.map((ss) => {
        if (ss.status === 'uploading') {
          const newSets = {
            ...ss,
            status: 'error',
          };

          return newSets;
        }

        return ss;
      });

      setFileList(newFileList);
      messageApi.error('ไม่สามารถอัปโหลดไฟล์นี้ได้ กรุณาลองใหม่อีกครั้ง');
    },
  });

  const onUploadChange = async ({ file, fileList }) => {
    setFileList(
      fileList.map((ss) => ({
        ...ss,
        status: ss.uid === file.uid ? 'uploading' : 'done',
      }))
    );

    if (file.status === 'done') {
      await mutateUpload({
        file: file.originFileObj,
        module: 'online_scam',
        group: 'case',
        uid: file.uid,
      });
    }
  };

  const onMoveToTrash = (uid) => {
    try {
      const newFileList = fileList.filter((ss) => ss.uid !== uid);
      onPresentFiles(newFileList);
      messageApi.success(`ลบไฟล์สำเร็จ`, 1000);
    } catch (error) {
      messageApi.error(`ไม่สามารถลบไฟล์นี้ได้ กรุณาลองใหม่อีกครั้ง`);
    }
  };

  useEffect(() => {
    if (defaults.length > 0) {
      setFileList(defaults);
    }
  }, [defaults]);

  return (
    <Space direction="vertical" style={{ marginBottom: 10, width: '100%' }}>
      {contextHolder}
      <Typography.Text strong>
        {required && <span style={{ color: '#ff0000' }}>*</span>} {title || 'อัปโหลดรูปภาพ'}
      </Typography.Text>
      {description && <Typography.Text>{description}</Typography.Text>}
      <Typography.Text>
        รูปภาพ {fileList.length || 0}/{maxLength} - คุณสามารถเพิ่มรูปภาพได้ถึง {maxLength} รูป
      </Typography.Text>

      <br />

      {fileList.length > 0 && (
        <DraggerSortableContainer
          maxLength={maxLength}
          fileList={fileList}
          loading={isPendingUpload}
          onSortableEnd={onPresentFiles}
          onUploadChange={onUploadChange}
          onRemove={onMoveToTrash}
        />
      )}

      <div style={{ display: fileList.length <= 0 ? 'initial' : 'none' }}>
        <DraggerZone loading={isPendingUpload} fileList={fileList} onChange={onUploadChange} />
      </div>
    </Space>
  );
}
